import React from "react"
import { Typography } from "@mui/material"


export default function timeColumn() {
	let id = 0
	return {
		name: 'Time from & to',
		render: (_, row) => <Typography>{`From ${row.timeFrom} to ${row.timeTo}`}</Typography>,
		setBodyCellProps: () => {
			id++
			return { sx: { backgroundColor: id % 2 === 0 || (id % 2 === 0 && id !== 0) ? "background.grey" : "background.lightGrey" } }
		}
	}
}